import axios from 'axios'
import store from '@/store/'

const axiosInstance = axios.create()

let counterId = 1
const checkIsCountingDisabled = (url) => {
  return !url || url.endsWith('/webhook')
}
const durationCounting = {
  data: {},
  start(id, url) {
    if (checkIsCountingDisabled(url)) return
    if (!this.data[id]) this.data[id] = { start: 0, end: 0 }
    this.data[id].start = performance.now()
  },
  end(id, url, method, wasError) {
    if (!this.data[id]) return
    this.data[id].end = performance.now()
    const duration = Math.round(this.data[id].end - this.data[id].start)
    store.dispatch('sendCrezuEvent', { id: 27, data: {
        sub1: 'backendResponseDuration',
        sub2: duration,
        sub3: url,
        sub4: method,
        sub5: !!wasError,
      }
    })
  }
}

axiosInstance.interceptors.request.use((request) => {
  const id = counterId++
  const url = request.url
  const method = request.method.toUpperCase()
  request.interceptorData = {
    id,
    url,
    method,
  }
  durationCounting.start(id, url)
  return request
}, (error) => {
  return Promise.reject(error)
})

axiosInstance.interceptors.response.use((response) => {
  const data = response.config.interceptorData
  durationCounting.end(data.id, data.url, data.method)
  return response
}, (error) => {
  const data = error.response.config.interceptorData
  durationCounting.end(data.id, data.url, data.method, true)
  return Promise.reject(error)
})

export default axiosInstance



// WEBPACK FOOTER //
// ./src/utils/api.js